import React from "react";
import { joinClasses } from "../../utils/joinClasses";
import { useTabContext } from "./tabs.context";
/**
 * Tab Bar component acts as a styling wrapper (and tablist role) for tabs
 */
export const TabBar = ({ children, className, }) => {
    const { tabType } = useTabContext();
    return (React.createElement("div", { className: joinClasses([
            "nxm-tab-bar",
            tabType === "primary" ? "nxm-tab-bar-primary" : "nxm-tab-bar-secondary",
            className,
        ]) },
        React.createElement("div", { className: "nxm-tab-bar-scroller", role: "tablist" }, children)));
};
